import baseRequest from '../baseRequest';
import AppConfig from '../../app/config/AppConfig';
import AnalyticsManager from '../../app/analytics';

/* actions */
import * as Actions from '../../redux/actions';

class Logout extends baseRequest {

    constructor() {
        super();
        this.dispatch = null;
        this.response = null;
        this.name = 'log out';
        this.Config = new AppConfig();
        this.route = null;
    }

    execute(dispatch) {
        this.dispatch = dispatch;
        // this.call(this.Config.api.requests.logout);
        this.call(this.Config.api.requests.logout, undefined, 'post', {
            //local
            // basePath: 'http://localhost:8083/users/api/auth',
            //dev
            basePath: '//' + window.apiUrl + '/users/api/auth',
            stringifyData: true,
          });
    }

    //Parse successful response
    onSuccess() {
        this.updateState();
    }

    //Dispatch actions to update redux state
    updateState() {
        AnalyticsManager.updateUserProperties({});
        this.dispatch(Actions.setUserData(false));
        this.dispatch(Actions.setUserOrders(false));
    }

    onFailure() {

    }
}


export default Logout;
